var map = {
	"./about-cropped.png": "b34b",
	"./about.jpg": "bc25",
	"./avatar/avatar-a.svg": "a299",
	"./avatar/avatar-alt.svg": "26ae",
	"./avatar/avatar-h.svg": "cea2",
	"./avatar/avatar.svg": "ebe7",
	"./bg.jpg": "3625",
	"./blank-wide.svg": "1658",
	"./blank.svg": "ba14",
	"./blob.png": "6732",
	"./blob.svg": "03ff",
	"./emoji/emoji-eyebrow.png": "06f4",
	"./emoji/emoji-smile.png": "b262",
	"./emoji/emoji-think.png": "c5df",
	"./emoji/emoji-wink.png": "c964",
	"./favicons/fav-face.svg": "dd24",
	"./favicons/fav.svg": "a5b2",
	"./favicons/favicon.svg": "b357",
	"./j-logo.svg": "5162",
	"./j-uni.svg": "f111",
	"./jacques.jpeg": "26bf",
	"./logo.png": "9d64",
	"./luna.jpg": "ed76",
	"./me.jpg": "535c",
	"./noise.png": "62d6",
	"./noise2.png": "7026",
	"./portrait.jpg": "ecba",
	"./profile.jpg": "4b94",
	"./profile2.jpg": "44ec",
	"./shapes.png": "a042",
	"./shapes.svg": "af6d",
	"./splash.svg": "dca9",
	"./splash4.svg": "7ae0",
	"./templates/archive/hand2.png": "b627",
	"./templates/archive/hands.png": "013a",
	"./templates/archive/template-desktop-mobile.svg": "b029",
	"./templates/archive/template-lg.svg": "d8e9",
	"./templates/archive/template-mobile-4.svg": "e3ef",
	"./templates/archive/template-mobile-v2.svg": "d659",
	"./templates/archive/template-sm.svg": "2206",
	"./templates/template-desktop-blank.svg": "404e",
	"./templates/template-mobile-blank.svg": "1d5c",
	"./templates/template-mobile.svg": "7731",
	"./templates/template-preview.svg": "df50",
	"./templates/template-v2.svg": "9e64",
	"./work/dod.svg": "0486",
	"./work/glo.svg": "6035",
	"./work/gob.svg": "868a",
	"./work/j.svg": "8502",
	"./work/mailback.svg": "f436",
	"./work/placeholder.png": "c542"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";